const unitsEnum = {
  m3Min: 'm3/min',
  cfm: 'CFM',
  celsius: 'celsius',
  '°C': '°C',
  powerKw: 'kw',
  percentage: '%',
  bar: 'bar',
};

Object.freeze(unitsEnum);

export default unitsEnum;
